if($('.type-posts-listing').length){
   
    function mhVypis(){
        if(!$('.vypisBlogu').length){
            $('#newsWrapper').before('<div class="vypisBlogu"></div><div class="flexik"><div class="custom-vypis"></div><div class="vypisBloguRight"><h2>Radi čítate</h2><div class="citateInner"></div></div></div>')
        }
        $('#newsWrapper .news-item:nth-child(-n+2)').appendTo('.vypisBlogu');

        $('#newsWrapper .news-item').appendTo('.custom-vypis');
        $('.news-item').each(function(){
            var readingSpeed = 800;
            var readingTime = $(this).text().length / readingSpeed;
            var htmlBlog = '<div class="text-custom">'
            htmlBlog += '<span class="title"><a href="'+$(this).find('.text>a').first().attr('href')+'">'+$(this).find('.text>a').first().text()+'</a></span>'
           
            if ($(this).find('p').first().text().length > 200) {
                var truncatedText = $(this).find('p').first().text().slice(0, 200) + "...";
                htmlBlog += '<p>'+truncatedText+'</p>'
            }
            else{
                var truncatedText = $(this).find('p').first().text();
                htmlBlog += '<p>'+truncatedText+'</p>'
            }
    
            
           // htmlBlog += '<span class="read-article">Čítať článok <i class="icon-arrow-right"></i></span>'
           htmlBlog += '<div class="reading-time"><span class="time">'+Math.ceil(readingTime)+' minút čítania</span></div>'
            htmlBlog += '</div>'
            if(!$(this).find('.text-custom').length){
               $(this).find('.text').after(htmlBlog)
            }
            
            
        })
    }
    $(document).ready(function(){
        mhVypis()
    })
    


   
    
    function products(){
      /*  if($('.product').length){
            $('.product').each(function(){
                if($(this).find('span[data-micro="sku"]').text() === '45'){
                    $(this).find('.p-bottom>div').append('<div class="dsc">'+popisProduktuNaHp+'</div>')
                }
                $(this).find('a.image img').attr('src', $(this).find('a.image img').attr('data-src').replace('/detail/', '/orig/'))
            })
        }*/
        
    }
    $(document).ready(function () {
        $('main#content .content-inner').append('<div class="products-wrapper"><div class="products-block"></div></div>')
        if(sessionStorage.productStorage) {
          $('main#content .products-block').append(sessionStorage.productStorage)
          
        } else {
          $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 1e4,
            cache: !0,
            url: "/",
            success: function(e) {
                var a = shoptet.common.createDocumentFromString(e),
                t = $(a).find(".products").html();
                console.log(t)
                null !== t && ($(".products-block").html(t), products())
                sessionStorage.productStorage = $(".products-block").html();
                }
            });
        }
    })

    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
        if($('#newsWrapper').length){
            mhVypis()
            function mhremove(){
                $('.citateInner .news-item').not(":nth-child(-n+3)").remove();
            }
            if(sessionStorage.blogRadi) {
              $('.citateInner').append(sessionStorage.blogRadi)
              $('.news-item').attr('style', 'opacity:1;')
            } else {
              $.ajax({
                type: "GET",
                dataType: "html",
                timeout: 1e4,
                cache: !0,
                url: "/radi-citate/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e),
                    t = $(a).find("#newsWrapper").html();
                    null !== t && ($(".citateInner").html(t), mhremove(), cteniClanku())
                    sessionStorage.blogRadi = $(".citateInner").html();
                    $('.news-item').attr('style', 'opacity:1;')
                    }
                });
            }
        }
    });
}